import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { GREENING_AGENT_LABEL } from './constants';
import { GreeningIcon } from './GreeningIcon';

interface Props {
  status?: string | null;
  questionsCount?: number;
}

/**
 * Indicador compacto na coluna Ações: folha Greening quando análise concluída;
 * numeral ao lado quando o usuário tem perguntas respondidas.
 */
export function GreeningTableBadge({ status, questionsCount = 0 }: Props) {
  if (status !== 'completed') {
    return null;
  }

  const count = Math.max(0, questionsCount);
  const title =
    count > 0
      ? `O agente ${GREENING_AGENT_LABEL} — ${count} pergunta${count === 1 ? '' : 's'} respondida${count === 1 ? '' : 's'}`
      : `Analisada pelo agente ${GREENING_AGENT_LABEL}`;

  return (
    <Tooltip title={title} arrow>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.375,
          flexShrink: 0,
          lineHeight: 0,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <GreeningIcon sx={{ fontSize: 22, display: 'block' }} />
        {count > 0 && (
          <Typography
            component="span"
            variant="caption"
            fontWeight={700}
            sx={{
              color: 'info.main',
              fontSize: '0.7rem',
              minWidth: 18,
              textAlign: 'center',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {count}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
}
